<template>
  <div class="">
    <cReviewHotel
      :hotelObj="hotelObj"
      :isToggleOption="true"
      :isEditOption="true"
      :isShowLeftPart="true"
      :isHideDetails="true"
    />

    <cRoomTypeInfo :hotelRoomObj="hotelRoomObj"> </cRoomTypeInfo>

    <ValidationObserver v-slot="{ handleSubmit }">
      <!-- <CForm @submit.prevent="handleSubmit(onSubmit)"> -->
        <CCard>
          <CCardHeader class="grey-header">
            <CRow class="flex-flow-column">
              <CCol>
                <strong
                  >{{
                    selRatePlan
                      ? $t("ratePlanNew.updateTitle")
                      : $t("ratePlanNew.title")
                  }}
                </strong>
              </CCol>

              <p class="desc">{{ $t("ratePlanNew.descTxt") }}</p>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <CRow v-if="selRatePlan">
              <CCol> </CCol>
              <CCol>
                <CContainer>
                  <div class="row">
                    <div
                      v-for="(mls, lindex) in selRatePlan.hotelRateplanMls"
                      :key="lindex + 'ml'"
                      @click="toggleLanguageModal(mls)"
                      :class="mls != 'en' ? 'col languagegrid' : ''"
                    >
                      <span v-if="mls != 'en'">{{ getLangName(mls) }}</span>
                    </div>
                    <div
                      class="col languagegrid"
                      @click="toggleLanguageModal(false)"
                    >
                      Add Language
                    </div>
                  </div>
                </CContainer>
              </CCol>
            </CRow>
            <br />
            <CRow v-if="selRatePlan">
              <CCol>
                {{ $t("ratePlanNew.status") }}
              </CCol>
              <cStatusButton
                v-if="ratePlanObj.isactive != null"
                class="generate-ex-btn label-margin-unset"
                :isConfirm="false"
                :defaultStatus="ratePlanObj.isactive"
                @change="ratePlanObj.isactive = !ratePlanObj.isactive"
                :label="{
                  checked: $t('ratePlanNew.active'),
                  unchecked: $t('ratePlanNew.inactive'),
                }"
              ></cStatusButton>
            </CRow>
            <CRow>
              <span>
                <strong>
                  {{ $t("ratePlanNew.ratePlanInfo") }}
                </strong>
              </span>
            </CRow>

            <section>
              <CRow>
                <cTextInputComponent
                  :rules="'required|noInitialSpace|max:150'"
                  v-model="ratePlanObj.name"
                  :label="$t('ratePlanNew.ratePlan')"
                  :placeholder="$t('ratePlanNew.ratePlanPh')"
                >
                </cTextInputComponent>
              </CRow>

              <CRow>
                <cTextInputComponent
                  :rules="'noInitialSpace|max:300'"
                  :label="$t('ratePlanNew.desc')"
                  :placeholder="$t('ratePlanNew.descPh')"
                  v-model="ratePlanObj.description"
                >
                </cTextInputComponent>
              </CRow>

              <CRow>
                <cCurrencyDropDown
                  :selValue="ratePlanObj.currency"
                  :label="$t('ratePlanNew.ratePlanCurr')"
                  :ctrlName="'code'"
                  :ctrlCode="'code'"
                  :isShowCode="true"
                  :isMultiple="false"
                  :isSearchable="true"
                  v-model="ratePlanObj.currency"
                  :url="getCurrencyServiceURL()"
                  :rules="'required'"
                  :defaultCurrencyCode="
                    ratePlanCurrency ? ratePlanCurrency : hotelObj.currency
                  "
                />
                <!-- //   :defaultCurrencyCode="hotelObj.currency" -->
              </CRow>
            </section>

            <CRow>
              <span>
                <strong>
                  {{ $t("ratePlanNew.appDays") }}
                </strong>
              </span>
            </CRow>

            <section>
              <CRow>
                <cTextInputComponent
                  v-model="ratePlanObj.minStay"
                  :rules="'required|noInitialSpace|onlynumber|max:3'"
                  :label="$t('ratePlanNew.minStay')"
                  :placeholder="$t('ratePlanNew.minStayPh')"
                >
                </cTextInputComponent>
                <div class="input-group-append align-curr">
                  <div></div>
                  <span
                    v-if="ratePlanObj.minStay <= 1"
                    class="input-group-text"
                    >{{ "Day" }}</span
                  >
                  <span
                    v-else-if="ratePlanObj.minStay > 1"
                    class="input-group-text"
                    >{{ "Days" }}</span
                  >
                  <!-- <span class="input-group-text">{{$tc('ratePlanNew.Day',ratePlanObj.minStay, { count: Number(ratePlanObj.minStay) }) }}</span> -->
                </div>
              </CRow>
              <CRow>
                <cTextInputComponent
                  v-model="ratePlanObj.maxStay"
                  :rules="
                    'required|noInitialSpace|onlynumber|max:3|min_value:' +
                      ratePlanObj.minStay
                  "
                  :name="'maximum stay'"
                  :label="$t('ratePlanNew.maxStay')"
                  :placeholder="$t('ratePlanNew.maxStayPh')"
                >
                </cTextInputComponent>
                <div class="input-group-append align-curr">
                  <div></div>
                  <span
                    v-if="ratePlanObj.maxStay <= 1"
                    class="input-group-text"
                    >{{ "Day" }}</span
                  >
                  <span
                    v-else-if="ratePlanObj.maxStay > 1"
                    class="input-group-text"
                    >{{ "Days" }}</span
                  >
                  <!-- <span class="input-group-text">{{$tc('ratePlanNew.Day',ratePlanObj.maxStay, { count: Number(ratePlanObj.maxStay) }) }}</span> -->
                </div>
              </CRow>
              <CRow>
                <CCol>
                  <div>
                    <span>
                      {{ $t("ratePlanNew.val") }}
                    </span>
                  </div>
                  <div class="ext-date-wrapper box-shadow left">
                    <ValidationProvider
                      v-slot="{ errors }"
                      vid="date"
                      rules="required"
                    >
                      <v-md-date-range-picker
                        v-model="ratePlanObj.validityFrom"
                        :ref="''"
                        :autoApply="true"
                        :showYearSelect="true"
                        :allowPastPresets="false"
                        :disableBefore="new Date().toString()"
                        @change="onChangeDate"
                      >
                        <template slot="input">
                          <datePickerInput
                            :fromDate="
                              ratePlanObj.validityFrom
                                ? ratePlanObj.validityFrom
                                : null
                            "
                            :toDate="
                              ratePlanObj.validityTo
                                ? ratePlanObj.validityTo
                                : null
                            "
                            :fromLabel="$t('ratePlanNew.fromDate')"
                            :toLabel="$t('ratePlanNew.toDate')"
                          />
                        </template>
                      </v-md-date-range-picker>
                      <div
                        v-if="errors && errors[0]"
                        class="invalid-feedback icon"
                      >
                        <span>
                          {{ errors[0] }}
                        </span>
                    
                      </div>
                           <span class="input-group-btn tooltipIconAlign d-flex ai-center right-pa-icon" >  
                <img src="@imgPath/img/svg/icons/help.svg" alt=""  width="15px"  v-c-tooltip.hover="{
                              content: $t('hotelInfo.datePickerToolTip'),
                            }" >                  

              </span>
                    </ValidationProvider>
                  </div>
                </CCol>
              </CRow>
            </section>

            <CRow>
              <span>
                <strong>
                  {{ $t("ratePlanNew.appDays") }}
                </strong>
              </span>
            </CRow>
            <section>
              <CRow>
                <CCol>
                    <label>
                  <input type='checkbox' v-model="showAdvPurchase">
                 
                      {{$t('ratePlanNew.advPurchase')}}
                  </label>
                 

                </CCol>
               
                  
               
                <div v-if='showAdvPurchase' class="input-group  flex-flow-row d-flex wrapper-prepend ">
                  <cTextInputComponent
                           label=' '
                           :key='showAdvPurchase+""'
                           :name="$t('ratePlanNew.advPurchase')"
                    :rules="'noInitialSpace|onlynumber|max:3'+showAdvPurchase?'|required|min_value:1':''"
                    :placeholder="$t('ratePlanNew.noOfDays')"
                    v-model="ratePlanObj.advPurchase"
                  >
                  </cTextInputComponent>
                  <div class="input-group-append align-curr">
                    <div></div>

                    <span
                      v-if="ratePlanObj.advPurchase <= 1"
                      class="input-group-text"
                      >{{ "Day" }}</span
                    >
                    <span
                      v-else-if="ratePlanObj.advPurchase > 1"
                      class="input-group-text"
                      >{{ "Days" }}</span
                    >
                  </div>
                  <cHelpTip
                    :content="$t('ratePlanNew.advPurDaysTooltip')"
                  ></cHelpTip>
                </div>
                 
              </CRow>

              <CRow>
                 <CCol>
                    <label>
                  <input type='checkbox' v-model="showPriceDrop">
                 
                      {{$t('ratePlanNew.priceDrop')}}
                  </label>
                 

                </CCol>
                <CCol v-if="showPriceDrop">
                  <div
                    class="input-group  flex-flow-row d-flex wrapper-prepend"
                  >
                    <cTextInputComponent
                      label=" "
                      :key='showPriceDrop+""'
                      :name="$t('ratePlanNew.priceDrop')"
                      :rules="'noInitialSpace|onlynumber|max:3'+showPriceDrop?'|required|min_value:1':''"
                      :placeholder="$t('ratePlanNew.noOfDays')"
                      v-model="ratePlanObj.lastMinPriceDropDays"
                    >
                    </cTextInputComponent>

                    <div class="input-group-append align-curr">
                      <div></div>

                      <span
                        v-if="ratePlanObj.lastMinPriceDropDays <= 1"
                        class="input-group-text"
                        >{{ "Day" }}</span
                      >
                      <span
                        v-else-if="ratePlanObj.lastMinPriceDropDays > 1"
                        class="input-group-text"
                        >{{ "Days" }}</span
                      >
                    </div>
                    <cHelpTip
                      :content="$t('ratePlanNew.lastminTooltip')"
                    ></cHelpTip>
                  </div>
                </CCol>
                <CCol  v-if="showPriceDrop">
                  <CRow>
                    <div class="input-group-prepend align-curr">
                      <select
                        class="input-group-text"
                        v-model="ratePlanObj.lastMinPriceDropSign"
                      >
                        <option>+</option>
                        <option>-</option>
                      </select>
                    </div>
                    <cTextInputComponent
                      :rules="
                        'required|noInitialSpace|onlynumber|max_value:100'
                      "
                      :label="$t('ratePlanNew.percPh')"
                      :placeholder="$t('ratePlanNew.percPh')"
                      v-model="ratePlanObj.lastMinPriceDropPercentage"
                    />
                    <div class="input-group-append align-curr">
                      <div></div>

                      <span class="input-group-text">{{ "%" }}</span>
                    </div>
                    <!-- <cHelpTip :content="$t('ratePlanNew.lastminTooltip')"></cHelpTip> -->
                  </CRow>
                </CCol>
              </CRow>
              <CRow>
                <cTextInputComponent
                  :label="$t('ratePlanNew.incGuest')"
                  :rules="'required|noInitialSpace|onlynumber|max:3'"
                  :placeholder="$t('ratePlanNew.incGuestPh')"
                  v-model="ratePlanObj.noOfPax"
                >
                </cTextInputComponent>
                <cHelpTip :content="$t('ratePlanNew.guestTooltip')"></cHelpTip>
              </CRow>
              <CCol>
                <CRow v-if="RATE_PLAN_PRICING">
                  <label for="FIXED">
                    <input
                      name="adultPriceType"
                      type="radio"
                      id="FIXED"
                      :value="RATE_PLAN_PRICING.FIXED"
                      v-model="ratePlanObj.extraAdultPriceType"
                    />
                    {{ $t("ratePlanNew.fixed") }}
                  </label>
                  <label for="PERCENTAGE">
                    <input
                      name="adultPriceType"
                      type="radio"
                      id="PERCENTAGE"
                      :value="RATE_PLAN_PRICING.PERC"
                      v-model="ratePlanObj.extraAdultPriceType"
                    />
                    {{ $t("ratePlanNew.perc") }}
                  </label>
                </CRow>

                <CRow>
                  <div
                    v-if="RATE_PLAN_PRICING"
                    class="input-group  flex-flow-row d-flex wrapper-prepend"
                  >
                    <div
                      v-if="
                        ratePlanObj.extraAdultPriceType !=
                          RATE_PLAN_PRICING.PERC
                      "
                      class="input-group-prepend align-curr"
                    >
                      <div></div>

                      <span
                        v-if="ratePlanObj.currency"
                        class="input-group-text"
                        >{{ ratePlanObj.currency.code }}</span
                      >
                    </div>
                    <cTextInputComponent
                      :label="$t('ratePlanNew.extraAdult')"
                      :placeholder="
                        ratePlanObj.extraAdultPriceType ==
                        RATE_PLAN_PRICING.PERC
                          ? $t('ratePlanNew.percPh')
                          : $t('ratePlanNew.enterAmount')
                      "
                      :rules="
                        'noInitialSpace|onlynumber|validDecimal' +
                          (ratePlanObj.extraAdultPriceType ==
                          RATE_PLAN_PRICING.PERC
                            ? '|max_value:100'
                            : '')
                      "
                      v-model="ratePlanObj.extraAdultPrice"
                    >
                    </cTextInputComponent>
                    <cHelpTip
                      :content="$t('ratePlanNew.extraAdtTooltip')"
                    ></cHelpTip>
                    <div class="input-group-prepend align-curr">
                      <div></div>

                      <span
                        v-if="
                          ratePlanObj.extraAdultPriceType ==
                            RATE_PLAN_PRICING.PERC
                        "
                        class="input-group-text"
                        >{{ "%" }}</span
                      >
                    </div>
                  </div>
                </CRow>
              </CCol>
              <CCol>
                <CRow>
                  <label for="CHILD_PRICE_FIXED">
                    <input
                      name="childPriceType"
                      type="radio"
                      id="CHILD_PRICE_FIXED"
                      :value="RATE_PLAN_PRICING.FIXED"
                      v-model="ratePlanObj.extraChildPriceType"
                    />
                    {{ $t("ratePlanNew.fixed") }}
                  </label>
                  <label for="CHILD_PRICE_PERCENTAGE">
                    <input
                      name="childPriceType"
                      type="radio"
                      id="CHILD_PRICE_PERCENTAGE"
                      :value="RATE_PLAN_PRICING.PERC"
                      v-model="ratePlanObj.extraChildPriceType"
                    />
                    {{ $t("ratePlanNew.perc") }}
                  </label>
                </CRow>

                <CRow>
                  <div
                    class="input-group  flex-flow-row d-flex wrapper-prepend"
                  >
                    <div
                      v-if="
                        ratePlanObj.extraChildPriceType !=
                          RATE_PLAN_PRICING.PERC
                      "
                      class="input-group-prepend align-curr"
                    >
                      <div></div>

                      <span
                        v-if="ratePlanObj.currency"
                        class="input-group-text"
                        >{{ ratePlanObj.currency.code }}</span
                      >
                    </div>
                    <cTextInputComponent
                      v-model="ratePlanObj.extraChildPrice"
                      :label="$t('ratePlanNew.extraChildRate')"
                      :placeholder="
                        ratePlanObj.extraChildPriceType ==
                        RATE_PLAN_PRICING.PERC
                          ? $t('ratePlanNew.percPh')
                          : $t('ratePlanNew.enterAmount')
                      "
                      :rules="
                        'noInitialSpace|onlynumber|validDecimal' +
                          (ratePlanObj.extraChildPriceType ==
                          RATE_PLAN_PRICING.PERC
                            ? '|max_value:100'
                            : '')
                      "
                    >
                    </cTextInputComponent>
                    <cHelpTip
                      :content="$t('ratePlanNew.extrachdTooltip')"
                    ></cHelpTip>
                    <div class="input-group-prepend align-curr">
                      <div></div>

                      <span
                        v-if="
                          ratePlanObj.extraChildPriceType ==
                            RATE_PLAN_PRICING.PERC
                        "
                        class="input-group-text"
                        >{{ "%" }}</span
                      >
                    </div>
                  </div>
                </CRow>
              </CCol>
            </section>
          </CCardBody>

          <CCardFooter class="d-flex justify-content-end">
            <div class="main-cta-btn">
              <CButton
                @click="navToHotelInfo()"
                color="danger"
                class="action-c-btn"
              >
                <img src="@imgPath/img/svg/icons/close.svg" />
                {{ $t("ratePlanNew.cancel") }}
              </CButton>
              <CButton
              @click.prevent.once="handleSubmit(onSubmit)"
                col="12"
                type="submit"
                color="success removewrap"
                class="action-c-btn"
              >
                <img src="@imgPath/img/svg/icons/correct.svg" />
                {{
                  selRatePlan
                    ? $t("ratePlanNew.update")
                    : $t("ratePlanNew.create")
                }}
              </CButton>
            </div>
          </CCardFooter>
        </CCard>
      <!-- </CForm> -->
    </ValidationObserver>
    <CModal
      size="xl"
      v-if="showLangForm"
      title="Add Language"
      :close-on-backdrop="false"
      centered
      :show.sync="showLangForm"
      fade
    >
      <template #footer>
        <div class=""></div>
      </template>

      <template #header>
        <div class="">
          <label>Add Language</label>
        </div>
      </template>
      <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
        <!-- <CForm > -->
        <CCardBody class="w-100 max-w-900 m-auto">
          <div v-if="hotelLangRes" class="subtitile-details">
            <CCol class="d-flex">
              <p class="v-center field-wrapper required-field">
                <label>{{ "Language code" }}</label>
              </p>
            </CCol>

            <div class="col">
              <ValidationProvider
                :rules="'required'"
                :vid="'1'"
                v-slot="{ errors }"
              >
                <multiselect
                  :multiple="false"
                  :allow-empty="false"
                  :placeholder="'Select the language code'"
                  v-model="rateplanLang.lang"
                  :options="hotelLangRes.allLanguage"
                  track-by="langcode"
                  label="langName"
                  deselectLabel
                  deselectGroupLabel
                  selectLabel
                  selectedLabel
                  v-on:input="onLanguageChange"
                  ><span slot="noResult"
                    ><strong>{{
                      $t("noMatchFound.noMatchFound")
                    }}</strong></span
                  >
                </multiselect>

                <div v-if="errors && errors[0]" class="invalid-feedback icon">
                  <div>
                    <span>{{ errors[0] }}</span>
                  </div>
                </div>
              </ValidationProvider>
            </div>
          </div>
          <div class="subtitile-details">
            <CCol class="d-flex">
              <p class="v-center field-wrapper required-field">
                <label>{{ "Rate Plan" }}</label>
              </p>
            </CCol>

            <div class="col">
              <cTextInputComponent
                v-model="rateplanLang.name"
                :placeholder="'Rate Plan'"
                class="w-100"
                :rules="'required|noInitialSpace'"
                :maxLength="150"
              ></cTextInputComponent>
            </div>
          </div>

          <div class="subtitile-details">
            <!-- <CCol class="d-flex">
                      <p class="v-center field-wrapper required-field">
                        <label>{{ $t('createHotel.description')}}</label>
                      </p>
                    </CCol> -->

            <div class="col-12">
              <label>{{ $t("createHotel.description") }}</label>
              <ValidationProvider
                v-slot="{ errors }"
                :rules="'required'"
              >
                <cRichTextEditor
                  v-model="rateplanLang.desc"
                  :selValue="rateplanLang.desc"
                  @getEditorText="onDesEditorChange"
                />

                <div v-if="errors && errors[0]" class="invalid-feedback icon">
                  <span>{{ errors[0] }}</span>
                </div>
                <div
                  v-else-if="alert.description"
                  class="invalid-feedback icon"
                >
                  <span>{{ alert.description }}</span>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </CCardBody>

        <div class="">
          <CRow class="justify-content-end">
            <CButton
              @click="toggleLanguageModal"
              color="danger"
              class="action-c-btn mr-15px"
              >{{ "Cancel" }}</CButton
            >
            <CButton
              type="submit"
              @click.prevent="handleSubmit(updateRateplanMl)"
              color="success"
              class="action-c-btn mr-15px"
            >
              {{
                selRatePlan &&
                rateplanLang.lang &&
                selRatePlan.hotelRateplanMls.includes(
                  rateplanLang.lang.langcode
                )
                  ? "Update"
                  : "Create"
              }}
            </CButton>
          </CRow>
        </div>

        <!-- </CForm> -->
      </ValidationObserver>
    </CModal>
    <cAlertModal
      v-if="showConfirmModal"
      :show="showConfirmModal"
      :buttonList="getConfirmModalButtons()"
      :status="2"
      :isShowIcon="true"
      :desc="$t('ratePlanNew.confirmDesc')"
    >
    </cAlertModal>
    <cAlertModal
      v-if="showSuccModal"
      :show="showSuccModal"
      :buttonList="getSuccModalButtons()"
      :status="1"
      :isShowIcon="true"
      :desc="
        selRatePlan ? $t('ratePlanNew.updateDesc') : $t('ratePlanNew.succDesc')
      "
    >
    </cAlertModal>
  </div>
</template>
<script>
import cReviewHotel from "../../../../../components/hms/cReviewHotel";
import {
  COMPONENT_NAME,
  DATE_TIME_FORMAT,
  PATHNAME,
} from "../../../../../util/constants";
import Logger from "../../../../../services/logger";
import multiselect from "vue-multiselect";
import BaseConfiguration from "../../../../../config/base.js";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage,
} from "../../../../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  OrderByList,
  cloneDeep,
  cloneData,
} from "../../../../../util/util";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES,
} from "../../../../../config/API_DATA";
import apiGetHotelRooms from "../../../../../services/apiGetHotelRooms";
import cTextInputComponent from "../../../../../components/form/cTextInputComponent";
import cAlertModal from "../../../../../components/form/cAlertModal";
import apiGetRatePlan from "../../../../../services/apiGetRatePlan";
import apiCreateRatePlan from "../../../../../services/apiCreateRatePlan";
import apiGetRatePlanInfo from "../../../../../services/apiGetRatePlanInfo";
import apiUpdateRatePlan from "../../../../../services/apiUpdateRatePlan";
import cRoomTypeInfo from "../../../../../components/hms/manage/hotelInfo/cRoomTypeInfo";

import apiUpdateRatePlanStatus from "../../../../../services/apiUpdateRatePlanStatus";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
import datePickerInput from "../../../../../components/datePicker/datePickerInput";
import { VMdDateRangePicker } from "material-vue-date-picker";

import cCurrencyDropDown from "../../../../../components/currency/cCurrencyDropDown.vue";
import Router, { goBack, navigate } from "../../../../../router";
import { addDays } from "../../../../../util/date/dateFunctions";

import cHelpTip from "../../../../../components/cHelpTip.vue";

import cStatusButton from "../../../../../components/form/cStatusButton.vue";
import apiGetHotelRatePlanMl from "../../../../../services/apiGetHotelRatePlanMl";
import apiUpdateHotelRatePlanMl from "../../../../../services/apiUpdateHotelRatePlanMl";

// import "quill/dist/quill.core.css";
// import "quill/dist/quill.snow.css";
// import "quill/dist/quill.bubble.css";
// import { quillEditor } from "vue-quill-editor";
import { i18n } from "../../../../../plugins/i18n";
import cRichTextEditor from "../../../../../components/form/cRichTextEditor";

export default {
  name: COMPONENT_NAME.RATE_PLAN_NEW,

  components: {
    cReviewHotel,
    cStatusButton,
    multiselect,
    cAlertModal,
    datePickerInput,
    VMdDateRangePicker,
    ValidationObserver,
    ValidationProvider,
    cHelpTip,
    cCurrencyDropDown,
    cRoomTypeInfo,
    cTextInputComponent,
    //  quillEditor,
    cRichTextEditor,
  },
  data: () => {
    return {
      showConfirmModal: false,
      showSuccModal: false,
      showLangForm: false,
      hotelLangRes: null,
      rateplanLang: {
        lang: null,
        roomName: null,
        desc: null,
      },
      alert: {
        description: null,
      },
      editorOption: {
        placeholder: i18n.tc("createHotel.descriptionPl"),
        theme: "snow",
      },
      updatedRateplanMlRes: null,
      showAdvPurchase:false,
      showPriceDrop:false,
      ratePlanObj: {
        hotelId: null,
        name: null,
        description: null,
        minStay: 0,
        maxStay: null,
        advPurchase: null,
        lastMinPriceDropDays: null,
        lastMinPriceDropSign: "+",
        lastMinPriceDropPercentage: null,
        currency: null,
        noOfPax: null,
        extraAdultPriceType: "FIXED",
        extraAdultPrice: null,
        extraChildPrice: null,
        extraChildPriceType: "FIXED",
        validityFrom: null,
        validityTo: null,
        roomId: null,
        isactive: null,
      },
    };
  },
  computed: {
    ...mapGetters("shmsManage", {
      hotelObj: "GET_SEL_HOTEL",

      RATE_PLAN_PRICING: "GET_RATE_PLAN_PRICING",
    }),
    ...mapGetters("sHotelInfo", {
      hotelRoomObj: "GET_HOTEL_ROOM_OBJ",
      GET_HOTEL_LANG: "GET_HOTEL_LANG",
     
    }),
    ...mapGetters("sRatePlan", {
      selRatePlan: "GET_SEL_RATE_PLAN",
      ratePlanCurrency: "GET_CURRENCY",
    }),
  },

  methods: {
    ...mapActions("sRatePlan", {
      SET_SEL_RATE_PLAN: "SET_SEL_RATE_PLAN",
      SET_CURRENCY: "SET_CURRENCY",
    }),
    

   
   
    async getRatePlanInfo(pRatePlanId) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getRatePlanInfo");

        if (this.hotelObj && pRatePlanId) {
          let ratePlanReq = apiGetRatePlanInfo.buildRequest(
            this.hotelObj.hotelid,
            pRatePlanId
          );

          if (ratePlanReq) {
            let ratePlanRes = await apiGetRatePlanInfo.getResponse(ratePlanReq);

            if (VALIDATE_SUCCESS_RES(ratePlanRes)) {
              retValue = ratePlanRes.data.data;
            } else {
              let error = getErrorMessage(ratePlanRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                getErrorAlertValue(error);
              }
            }
          }
        } else {
          throw "invalid hotel  obj or rate plan";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.RATE_PLAN_NEW,
          "error in getRatePlanInfo",
          err.toString(),
          "getRatePlanInfo",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }

      return retValue;
    },
    getLangName(pLangCode) {
      let retValue = null;
      let langname;
      try {
        if (BaseConfiguration.isDebug) console.log("getLangName");
        if (this.hotelLangRes) {
          retValue = this.hotelLangRes.allLanguage.filter((lanObj) => {
            if (lanObj.langcode == pLangCode) {
              return lanObj.langName;
            }
          });
        }
        if (retValue && retValue[0] && retValue[0].langName) {
          langname = retValue[0].langName;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.RATE_PLAN_NEW,
          "error in getLangName",
          err.toString(),
          "getLangName",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return langname;
    },
    onDesEditorChange(pEditorText, pAlertValue) {
      try {
        if (BaseConfiguration.isDebug) console.log("onDesEditorChange");
        this.rateplanLang.desc = pEditorText;
        this.alert.description = pAlertValue;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_HOTEL_ROOM_DET,
          "error in onDesEditorChange",
          err.toString(),
          "onDesEditorChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    async onLanguageChange(pLang) {
      try {
        if (BaseConfiguration.isDebug) console.log("onLanguageChange");

        let reqBody = {
          hotelId: this.hotelObj.hotelid,
          roomId: this.hotelRoomObj.roomid,
          ratePlanId: this.selRatePlan.id,
          langCode: this.rateplanLang.lang.langcode,
        };
        this.updatedRateplanMlRes = await this.getRateplanMl(reqBody);
        if (this.updatedRateplanMlRes) {
          this.rateplanLang.name = this.updatedRateplanMlRes.name;
          this.rateplanLang.desc = this.updatedRateplanMlRes.description;
          this.$refs.obs.reset();
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.RATE_PLAN_NEW,
          "error in onLanguageChange",
          err.toString(),
          "onLanguageChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async toggleLanguageModal(pLangcode) {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleLanguageModal");
        if (this.hotelLangRes && pLangcode != "en") {
          for (
            let index = 0;
            index < this.hotelLangRes.allLanguage.length;
            index++
          ) {
            if (pLangcode == this.hotelLangRes.allLanguage[index].langcode) {
              this.rateplanLang.lang = this.hotelLangRes.allLanguage[index];
              break;
            }
          }
        }
        let txtalert = this.alert;
        for (var i in txtalert) {
          if (txtalert[i]) {
            txtalert[i] = null;
          }
        }
        this.showLangForm = !this.showLangForm;

        if (this.showLangForm) {
          this.hotelLangRes.allLanguage = this.hotelLangRes.allLanguage.filter(
            (lang) => lang.langcode != "en"
          );
          if (pLangcode != false && pLangcode != "en") {
            let reqBody = {
              hotelId: this.hotelObj.hotelid,
              roomId: this.hotelRoomObj.roomid,
              ratePlanId: this.selRatePlan.id,
              langCode: this.rateplanLang.lang.langcode,
            };
            this.updatedRateplanMlRes = await this.getRateplanMl(reqBody);
            if (this.updatedRateplanMlRes) {
              this.rateplanLang.name = this.updatedRateplanMlRes.name;
              this.rateplanLang.desc = this.updatedRateplanMlRes.description;
            }
          } else if (pLangcode == false) {
            this.rateplanLang.lang = null;
            //   this.rateplanLang.name = this.ratePlanObj.name;
            // this.rateplanLang.desc = this.ratePlanObj.description;
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.RATE_PLAN_NEW,
          "error in toggleLanguageModal",
          err.toString(),
          "toggleLanguageModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async getRateplanMl(pReqBody) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getRateplanMl");
        if (this.hotelObj) {
          let RoomMlRequest = apiGetHotelRatePlanMl.buildRequest(pReqBody);

          if (RoomMlRequest) {
            let RoomMlResponse = await apiGetHotelRatePlanMl.getResponse(
              RoomMlRequest
            );

            if (VALIDATE_SUCCESS_RES(RoomMlResponse)) {
              this.alertValue = null;
              retValue = RoomMlResponse.data.data;
            } else {
              let error = getErrorMessage(RoomMlResponse);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                this.alertValue = getErrorAlertValue(error);
              }
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.RATE_PLAN_NEW,
          "error in getRateplanMl",
          err.toString(),
          "getRateplanMl",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    isValidTextValues(pAlert) {
      let retValue = true;
      try {
        if (BaseConfiguration.isDebug) console.log("isValidTextValues");
        for (let i = 0; i < Object.keys(pAlert).length; i++) {
          if (pAlert[Object.keys(pAlert)[i]]) {
            retValue = false;
            break;
          } else {
            retValue = true;
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.RATE_PLAN_NEW,
          "error in isValidTextValues",
          err.toString(),
          "isValidTextValues",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async updateRateplanMl() {
      try {
        if (BaseConfiguration.isDebug) console.log("updateRateplanMl");
        let reqBody = {
          hotelId: this.hotelObj.hotelid,
          roomId: this.hotelRoomObj.roomid,
          ratePlanId: this.selRatePlan.id,
          langCode: this.rateplanLang.lang.langcode,
          description: this.rateplanLang.desc,
          name: this.rateplanLang.name,
        };
        var isValid = this.isValidTextValues(this.alert);
        if (this.hotelObj && isValid) {
          let updateMlRequest = apiUpdateHotelRatePlanMl.buildRequest(reqBody);

          if (updateMlRequest) {
            let updateMlResponse = await apiUpdateHotelRatePlanMl.getResponse(
              updateMlRequest
            );

            if (VALIDATE_SUCCESS_RES(updateMlResponse)) {
              this.alertValue = null;
              let updateResponse = updateMlResponse.data.data;

              if (updateResponse.rateplanid) {
                let ratePlanInfo = await this.getRatePlanInfo(
                  updateResponse.rateplanid
                );

                if (ratePlanInfo && ratePlanInfo.ratePlan != null)
                  this.SET_SEL_RATE_PLAN(ratePlanInfo.ratePlan);
              }

              this.showLangForm = !this.showLangForm;
            } else {
              let error = getErrorMessage(updateMlResponse);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                this.alertValue = getErrorAlertValue(error);
              }
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.RATE_PLAN_NEW,
          "error in updateRateplanMl",
          err.toString(),
          "updateRateplanMl",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },


    validateRateplan() {
        try {
          if(BaseConfiguration.isDebug) console.log("validateRateplan");
         if(!this.showPriceDrop)
         {
           this.ratePlanObj.lastMinPriceDropDays=null
         }
         if(!this.showAdvPurchase )
         {
           this.ratePlanObj.advPurchase=null;
         }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.RATE_PLAN_NEW,
                  "error in validateRateplan",
                  err.toString(),
                  "validateRateplan",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        
        }, 

    async onSubmit() {
      try {
        if (BaseConfiguration.isDebug) console.log("onSubmit");
        let createdRes;
        let updatedRes;
        let updateStatus;
        this.validateRateplan()
        if (this.selRatePlan) {
          if (this.selRatePlan.isactive != this.ratePlanObj.isactive) {
            updateStatus = await this.updateRatePlanStatus();
          }

          updatedRes = await this.updateRatePlan();
        } else {
          createdRes = await this.createRatePlan();
        }

        if (
          (createdRes && createdRes.id) ||
          (updatedRes &&
            updatedRes.isSuccess &&
            (this.selRatePlan.isactive != this.ratePlanObj.isactive
              ? updateStatus
              : true))
        ) {
          this.toggleSuccModal();
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.RATE_PLAN_NEW,
          "error in onSubmit",
          err.toString(),
          "onSubmit",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    navToHotelInfo() {
      try {
        if (BaseConfiguration.isDebug) console.log("navToHotelInfo");

        goBack();
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.RATE_PLAN_NEW,
          "error in navToHotelInfo",
          err.toString(),
          "navToHotelInfo",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    setValidity(pRateplanObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("setValidity");

        pRateplanObj.validityFrom = this.$options.filters.formatDate(
          new Date(),
          DATE_TIME_FORMAT.API_DATE_FORMAT
        );
        pRateplanObj.validityTo = this.$options.filters.formatDate(
          addDays(new Date(), 7),
          DATE_TIME_FORMAT.API_DATE_FORMAT
        );
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.RATE_PLAN_NEW,
          "error in setValidity",
          err.toString(),
          "setValidity",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getSuccModalButtons() {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getSuccModalButtons");

        retValue = [
          {
            name: this.$t("ratePlanNew.Ok"),
            func: this.navToHotelInfo,
          },
        ];
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.RATE_PLAN_NEW,
          "error in getSuccModalButtons",
          err.toString(),
          "getSuccModalButtons",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }

      return retValue;
    },

    getConfirmModalButtons() {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getConfirmModalButtons");

        retValue = [
          {
            name: this.$t("ratePlanNew.stay"),
            func: this.toggleConfirmModal,
          },
          {
            name: this.$t("ratePlanNew.leave"),
            func: this.navToHotelInfo,
          },
        ];
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.RATE_PLAN_NEW,
          "error in getConfirmModalButtons",
          err.toString(),
          "getConfirmModalButtons",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    toggleConfirmModal() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleConfirmModal");

        // this.showConfirmModal = !this.showConfirmModal;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.RATE_PLAN_NEW,
          "error in toggleConfirmModal",
          err.toString(),
          "toggleConfirmModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    toggleSuccModal() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleSuccModal");

        this.showSuccModal = !this.showSuccModal;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.RATE_PLAN_NEW,
          "error in toggleSuccModal",
          err.toString(),
          "toggleSuccModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getCurrencyServiceURL() {
      if (BaseConfiguration.isDebug) console.log("getCurrencyServiceURL");
      return SERVICE_URL.GET_CURRENCY_LIST;
    },

    async updateRatePlanStatus() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("updateRatePlanStatus");

        if (this.hotelObj && this.hotelRoomObj) {
          let ratePlanReq = apiUpdateRatePlanStatus.buildRequest(
            cloneDeep(this.ratePlanObj),
            this.hotelObj.hotelid
          );

          if (ratePlanReq) {
            let ratePlanRes = await apiUpdateRatePlanStatus.getResponse(
              ratePlanReq
            );

            if (VALIDATE_SUCCESS_RES(ratePlanRes)) {
              retValue = ratePlanRes.data.data;
            } else {
              let error = getErrorMessage(ratePlanRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                getErrorAlertValue(error);
              }
            }
          }
        } else {
          throw "invalid hotel  obj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.RATE_PLAN_NEW,
          "error in updateRatePlan",
          err.toString(),
          "updateRatePlan",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async createRatePlan() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("createRatePlan");

        if (this.hotelObj && this.hotelRoomObj) {
          let ratePlanReq = apiCreateRatePlan.buildRequest(
            cloneDeep(this.ratePlanObj),
            this.hotelObj.hotelid,
            this.hotelRoomObj.roomid
          );

          if (ratePlanReq) {
            let ratePlanRes = await apiCreateRatePlan.getResponse(ratePlanReq);

            if (VALIDATE_SUCCESS_RES(ratePlanRes)) {
              retValue = ratePlanRes.data.data;
            } else {
              let error = getErrorMessage(ratePlanRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                getErrorAlertValue(error);
              }
            }
          }
        } else {
          throw "invalid hotel  obj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.RATE_PLAN_NEW,
          "error in createRatePlan",
          err.toString(),
          "createRatePlan",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async updateRatePlan() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("updateRatePlan");

        if (this.hotelObj && this.hotelRoomObj) {
          let ratePlanReq = apiUpdateRatePlan.buildRequest(
            cloneDeep(this.ratePlanObj),
            this.hotelObj.hotelid,
            this.hotelRoomObj.roomid
          );

          if (ratePlanReq) {
            let ratePlanRes = await apiUpdateRatePlan.getResponse(ratePlanReq);

            if (VALIDATE_SUCCESS_RES(ratePlanRes)) {
              retValue = ratePlanRes.data.data;
            } else {
              let error = getErrorMessage(ratePlanRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                getErrorAlertValue(error);
              }
            }
          }
        } else {
          throw "invalid hotel  obj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.RATE_PLAN_NEW,
          "error in updateRatePlan",
          err.toString(),
          "updateRatePlan",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    onChangeDate(pDateList) {
      try {
        if (BaseConfiguration.isDebug) console.log("onChangeDate");
        //  console.error(pDateList)
        //    this.fromDate=pDateList[0]._d;

        if (pDateList) {
          this.ratePlanObj.validityFrom = this.$options.filters.formatDate(
            pDateList[0]._d,
            DATE_TIME_FORMAT.API_DATE_FORMAT
          );
          this.ratePlanObj.validityTo = this.$options.filters.formatDate(
            pDateList[1]._d,
            DATE_TIME_FORMAT.API_DATE_FORMAT
          );
        }
        //  this.toDate=pDateList[1]._d;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.RATE_PLAN_NEW,
          "error in onChangeDate",
          err.toString(),
          "onChangeDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    setRatePlanObj(pSelRatePlanObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("setRatePlanObj");
        if (pSelRatePlanObj && pSelRatePlanObj.id)
        {
          this.ratePlanObj = {
            id: pSelRatePlanObj.id,
            isactive: pSelRatePlanObj.isactive,
            hotelId: null,
            name: pSelRatePlanObj.name,
            description: pSelRatePlanObj.description,
            minStay:pSelRatePlanObj.minstay!=null? pSelRatePlanObj.minstay+'':pSelRatePlanObj.minstay,
            maxStay: pSelRatePlanObj.maxstay!=null? pSelRatePlanObj.maxstay+'':pSelRatePlanObj.maxstay,
            advPurchase:pSelRatePlanObj.advpurchaseDays!=null? pSelRatePlanObj.advpurchaseDays+'':pSelRatePlanObj.advpurchaseDays,
            lastMinPriceDropDays:pSelRatePlanObj.lastminutePricedropDays!=null? pSelRatePlanObj.lastminutePricedropDays+'':pSelRatePlanObj.lastminutePricedropDays,
            lastMinPriceDropSign:
              (pSelRatePlanObj.lastminutePricedropPercent &&
                parseFloat(pSelRatePlanObj.lastminutePricedropPercent)) < 0
                ? "-"
                : "+",
            lastMinPriceDropPercentage:
              parseFloat(pSelRatePlanObj.lastminutePricedropPercent) != 0
                ? Math.abs(pSelRatePlanObj.lastminutePricedropPercent)
                : "0",
            currency: {
              code: pSelRatePlanObj.currency,
            },
            noOfPax: pSelRatePlanObj.noOfPax!=null? pSelRatePlanObj.noOfPax+'':pSelRatePlanObj.noOfPax,
            extraAdultPriceType: pSelRatePlanObj.extraAdultpriceType,
            extraAdultPrice: pSelRatePlanObj.extraAdultprice!=null? pSelRatePlanObj.extraAdultprice+'':pSelRatePlanObj.extraAdultprice,
            extraChildPrice: pSelRatePlanObj.extraChildprice!=null? pSelRatePlanObj.extraChildprice+'':pSelRatePlanObj.extraChildprice,
            extraChildPriceType: pSelRatePlanObj.extraChildpriceType,
            validityFrom: pSelRatePlanObj.validityFrom,
            validityTo: pSelRatePlanObj.validityTo,
            roomId: null,
          };


           this.showAdvPurchase= pSelRatePlanObj.isadvpurchaseEnabled
           this.showPriceDrop =pSelRatePlanObj.islastminuteEnabled
        }
        else {
          throw "invalid rate plan obj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.RATE_PLAN_NEW,
          "error in setRatePlanObj",
          err.toString(),
          "setRatePlanObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    // async handleRouteQuery() {
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("handleRouteQuery");
    //     if (
    //       Router &&
    //       Router.currentRoute &&
    //       Router.currentRoute.query &&
    //       Router.currentRoute.query.roomId
    //     ) {
         
    //     }
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       FILE_NAME.RATE_PLAN_NEW,
    //       "error in handleRouteQuery",
    //       err.toString(),
    //       "handleRouteQuery",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // },
  },

  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");

      if (this.selRatePlan) {
        let ratePlanInfo = await this.getRatePlanInfo(this.selRatePlan.id);

        if (ratePlanInfo && ratePlanInfo.ratePlan != null)
          this.SET_SEL_RATE_PLAN(ratePlanInfo.ratePlan);

        this.setRatePlanObj(cloneDeep(this.selRatePlan));
      } else {
       // await this.handleRouteQuery();
      }

      if (this.GET_HOTEL_LANG) {
        this.hotelLangRes = this.GET_HOTEL_LANG;
      } else {
        this.hotelLangRes = await this.getHotelLang();
      }
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.RATE_PLAN_NEW,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
};
</script>
<style scoped>
.align-curr {
  margin-top: 29px;
}
</style>
